import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer, mergeAttributes } from "@tiptap/react";

import { Renderer } from "./Renderer";

export const CTAExtension = Node.create({
  name: "cta",
  group: "block",
  atom: true,
  addAttributes: () => ({
    url: {
      default: null,
    },
    label: {
      default: null,
    },
    color: {
      default: null,
    },
    text_color: {
      // Text color option was added after the initial release of the CTA extension. It was set to #FFFFFF by default.
      // This is to ensure backwards compatibility with existing content.
      default: "#FFFFFF",
    },
    full_width: {
      default: false,
    },
    may_lead_to_purchase: {
      default: false,
    },
    alignment: {
      default: "center",
    },
  }),
  parseHTML: () => [{ tag: "cta-react" }],
  renderHTML: ({ HTMLAttributes }) => [
    "cta-react",
    mergeAttributes(HTMLAttributes),
  ],
  addNodeView: () => ReactNodeViewRenderer(Renderer),
});
